// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__GTAmerica_a9f72b', '__GTAmerica_Fallback_a9f72b', helvetica, arial, sans-serif"},"className":"__className_a9f72b"};